import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <>

            <footer className="footer-section v3">
                <div className="footer-content v3">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-xl-4 col-md-6 col-12">
                                <div className="footer-widget">
                                    <div className="footer-logo">
                                        <img src="/assets/images/logo2.png" alt="logo" />
                                    </div>
                                    <p className="widget-para">
                                        Axborotni tanqidiy tahlil qilish, tekshirish va xolis baholash qobiliyatlarini shakllantirishga qaratilgan raqamli ta’lim vositasi.
                                    </p>
                                    <ul className="footer-social-link">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-telegram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="my-icon icon-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="my-icon icon-youtube"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="my-icon icon-instagram"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-6 col-12">
                                <div className="footer-widget">
                                    <h4 className="widget-title">Havolalar</h4>
                                    <ul className="quick-links">
                                        <li>
                                            <Link to='/'>Bosh sahifa</Link>
                                        </li>
                                        <li>
                                            <Link to='/videos'>Videodarslar</Link>
                                        </li>
                                        <li>
                                            <Link to='/maruza'>Ma'ruzalar</Link>
                                        </li>
                                        <li>
                                            <Link to='/seminar'>Seminarlar</Link>
                                        </li>
                                        <li>
                                            <Link to="/about">Loyiha haqida</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-6 col-12">
                                <div className="footer-widget">
                                    <h4 className="widget-title">Yangiliklar uchun</h4>
                                    <div className="get-newsletter">
                                        <p className="para">Yangiliklardan xabardor bo'lish uchun pochtangizni jo'nating!</p>
                                        <div className="email-address">
                                            <form>
                                                <i className="my-icon icon-massage-2"></i>
                                                <input type="search" placeholder="Elektron pochta kiriting" />
                                            </form>
                                        </div>
                                        <div className="all-btn">
                                            <a href="#" className="btn-p v2 btn-blue2 rounded">Jo'natish</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="copyright-section v1">
                <div className="container">
                    <div className="copyright-content">
                        <div className="left-content">
                            <p className="para">© {new Date().getFullYear()} <span>Mediasavodxonlik.</span> Barcha huquqlar himoyalangan.</p>
                        </div>
                        <div className="right-content">
                            <a href="https://t.me/MirjalolUrozboev" className="para2">Yordam</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer